import { rootPath } from '../routes'
import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { httpPost, httpGet, httpDelete } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'

const LOGIN = makeKeys('LOGIN')
const VALIDATE = makeKeys('VALIDATE')
const LOGOUT = makeKeys('LOGOUT')
const SHOW_LOGIN = 'SHOW_LOGIN'
const USER_ADMIN = makeKeys('USER_ADMIN')
const SHOW_REGISTER = 'SHOW_REGISTER'
const SHOW_FORGOT_PASSWORD = 'SHOW_FORGOT_PASSWORD'
const SHOW_RESEND_CONFIRM_MAIL = 'SHOW_RESEND_CONFIRM_MAIL'

export const login = makeAction(LOGIN.REQUEST, 'data','history')
export const validate = makeAction(VALIDATE.REQUEST, 'history')
export const logout = makeAction(LOGOUT.REQUEST, 'history')
export const showLogin = makeAction(SHOW_LOGIN)
export const showRegister = makeAction(SHOW_REGISTER)
export const showForgotPassword = makeAction(SHOW_FORGOT_PASSWORD)
export const showResendConfirmEmail = makeAction(SHOW_RESEND_CONFIRM_MAIL)

export const setUserAdmin = makeAction(USER_ADMIN.REQUEST, 'roles')
const setUserAdminSuccess = makeAction(USER_ADMIN.SUCCESS, 'isAdmin')

const loginSuccess = makeAction(LOGIN.SUCCESS, 'data')
const validateSuccess = makeAction(VALIDATE.SUCCESS, 'data')
const logoutSuccess = makeAction(LOGOUT.SUCCESS)

const loginFailure = makeAction(LOGIN.FAILURE)
const validateFailure = makeAction(VALIDATE.FAILURE)
const logoutFailure = makeAction(LOGOUT.FAILURE)

const initial = {
  user: {},
  userAdmin:false,
  loading: false,
  isLogin: true,
  isRegister: false,
  isForgotPassword: false,
  isResendConfirmMail: false,
  validating: false,
  validateSuccess: true,
  validatedMessage: '',
}

function* loginRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost('authen/login', data)
    yield put(appLoaded())

    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        localStorage.setItem('username', response.data.username)
        localStorage.setItem('roles', response.data.roles)
        localStorage.setItem('mainDeptCode', response.data.mainDeptCode)
        localStorage.setItem('subDeptCode', response.data.subDeptCode)
        yield put(setUserAdminSuccess(checkRoleAdmin(response.data.roles)))
        yield put(loginSuccess(response.data))
        history.replace(history.location.pathname)
      }
    }

  } catch (e) {
    yield put(appLoaded())
    yield put(loginFailure())
    yield put(toastError('The username or password is incorrect. Please check them and try again.'))
  }
}

function checkRoleAdmin(role){
  return role.findIndex(i => i.name.toLowerCase() === "admin")>=0
}

function* setUserAdminRequest(action) {
  const { roles } = action.payload
  yield put(setUserAdminSuccess(checkRoleAdmin(roles)))
}

function* validateRequest(action) {
  const { history } = action.payload
  try {
    const response = yield httpGet('authen/validate')

    if (response.status >= 200 && response.status < 300) {
      if (response.data) {

        if (response.data.maintenanceTime === null) {
          localStorage.removeItem('maintenanceDescription')
          localStorage.removeItem('maintenanceStartTime')
          localStorage.removeItem('maintenanceEndTime')
        }

        localStorage.setItem('username', response.data.username)
        localStorage.setItem('mainDeptCode', response.data.mainDeptCode)
        localStorage.setItem('subDeptCode', response.data.subDeptCode)
        localStorage.setItem('roles', response.data.roles)
        yield put(setUserAdminSuccess(response.data.isAdmin))
        yield put(validateSuccess(response.data))
        if (history && history.location.pathname === '/') {
          history.replace(rootPath)
        }
      }
    }
  } catch (e) {
    if (e && e.status === 401) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('username')
      localStorage.removeItem('mainDeptCode')
      localStorage.removeItem('subDeptCode')
      localStorage.removeItem('roles')
      if (history) {
        history.replace(rootPath)
      }
    }
    yield put(validateFailure())
    yield put(toastError('The username or email is already login in another device or token expired.'))
  }
}

function* logoutRequest(action) {
  const { history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpDelete('authen/logout')
    yield put(appLoaded())

    if (response.status >= 200 && response.status < 300) {
      yield put(logoutSuccess())
      yield put(setUserAdminSuccess(false))
      yield put(toastSuccess(response.data.message))
    }
    history.replace('/')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('roles')
    localStorage.removeItem('mainDeptCode')
    localStorage.removeItem('subDeptCode')
  } catch (e) {
    yield put(appLoaded())
    yield put(logoutFailure())
    history.replace('/')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('roles')
    localStorage.removeItem('mainDeptCode')
    localStorage.removeItem('subDeptCode')
  }
}

export function* watchAuthenSaga() {
  yield takeLatest(LOGIN.REQUEST, loginRequest)
  yield takeLatest(VALIDATE.REQUEST, validateRequest)
  yield takeLatest(LOGOUT.REQUEST, logoutRequest)
  yield takeLatest(USER_ADMIN.REQUEST, setUserAdminRequest)
}

export default createReducer(initial, state => ({
  [LOGIN.REQUEST]: () => ({
    ...state,
    user: null,
    loading: true
  }),
  [LOGIN.SUCCESS]: (data) => ({
    ...state,
    user: data.data,
    loading: false
  }),
  [LOGIN.FAILURE]: () => ({
    ...state,
    user: null,
    loading: false
  }),
  [VALIDATE.REQUEST]: () => ({
    ...state,
    user: {},
    loading: true
  }),
  [VALIDATE.SUCCESS]: (data) => ({
    ...state,
    user: data.data,
    loading: false
  }),
  [VALIDATE.FAILURE]: () => ({
    ...state,
    user: null,
    loading: false
  }),
  [LOGOUT.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [LOGOUT.SUCCESS]: (data) => ({
    ...state,
    user: null,
    loading: false
  }),
  [LOGOUT.FAILURE]: () => ({
    ...state,
    user: null,
    loading: false
  }),
  [SHOW_LOGIN]: () => ({
    ...state,
    isLogin: true,
    isRegister: false,
    isForgotPassword: false,
    isResendConfirmMail: false
  }),
  [SHOW_REGISTER]: () => ({
    ...state,
    isLogin: false,
    isRegister: true,
    isForgotPassword: false,
    isResendConfirmMail: false
  }),
  [SHOW_FORGOT_PASSWORD]: () => ({
    ...state,
    isLogin: false,
    isRegister: false,
    isForgotPassword: true,
    isResendConfirmMail: false
  }),
  [SHOW_RESEND_CONFIRM_MAIL]: () => ({
    ...state,
    isLogin: false,
    isRegister: false,
    isForgotPassword: false,
    isResendConfirmMail: true
  }),
  [USER_ADMIN]: (data) => ({
    ...state,
    userAdmin: data.isAdmin
  })
}))
